export default {"src":"/oferta/_next/static/media/muscle.d2d5d488.svg","height":38,"width":39,"blurWidth":0,"blurHeight":0};